<template>
  <main class="login-page">
    <img class="login-logo" src="../../static/images/land/logo.png" alt="Go Quiz">
    <img class="login-title-art" src="../../static/images/land/land_text.png" alt="">
    <img class="login-prize-art" src="../../static/images/land/main_prize.png" alt="">

    <section class="login-form-area" :aria-label="$t('loginTips')">
      <div class="login-form-heading">
        <img src="../../static/images/land/package_line.png" alt="">
        <span>{{$t('loginTips')}}</span>
      </div>

      <div class="login-phone-field">
        <img class="login-phone-field-bg" src="../../static/images/login/phone_input_bg.png" alt="">
        <img class="login-phone-prefix" src="../../static/images/login/09.png" alt="09">
        <input class="login-phone-input" v-model="mobile" type="number" placeholder="" aria-label="Phone number">
      </div>

      <button type="button" class="login-subscribe-button" @click="goLogin()">
        <img src="../../static/images/login/sub_btn_bg.png" alt="">
        <span :class="{ 'login-subscribe-label-burmese': $i18n.locale === 'bur' }">{{$t('subscribe')}}</span>
      </button>
    </section>

    <nav class="login-footer" aria-label="Support links">
      <button type="button" class="login-footer-link" @click="getToNav('termsAndCondition')">
        {{$t('AccountTC')}} <span class="app-en">&gt;&gt;</span>
      </button>
      <button type="button" class="login-footer-link" @click="getToNav('faq')">
        {{$t('AccountFAQ')}} <span class="app-en">&gt;&gt;</span>
      </button>
    </nav>

	</main>
</template>
<script>
import Header from '../components/HeaderTwo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        password:'',
        type:'daily',
      }
    },
	created(){
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    let that = this
    if (this.$route.query.mobile){
      that.mobile = this.$route.query.mobile;
    }
    if (this.$route.query.type){
      that.type = this.$route.query.type;
    }
	},
  methods: {
      getToNav(url){
        this.$router.push({path:'/'+url});
      },
      back(){
        this.$router.go(-1);
      },
		  goLogin(){
        let that = this
        if(!this.mobile){
          that.$utils.alertText(that.$t('loginTips'),80)
        }else{
          this.checkMobile();
          // this.startSub();
          // this.testLogin()
        }
		},
    checkMobile(){
      let that = this
      that.$parent.loadModal(true);
      let mobile = '09'+this.mobile
      let data = {
        "mobile":mobile
      }
      //检测号码
      that.$api.post('/api/user/check_user',data,r =>{
        that.$parent.loadModal(false);
        if(r.code==1){
          localStorage.setItem('token',r.data.userinfo.token)
          localStorage.setItem('mobile',r.data.userinfo.mobile)
          this.$router.push({path:'/'})
        }else if(r.code==-1){
          this.startSub()
        } else{
          that.$utils.alertText(r.msg,100,3000);
        }
      })
    },
    //直接订阅登录
    startSub(){
      let that = this
      that.$parent.loadModal(true);
      let mobile = '09'+this.mobile
      let type  = this.type
      let queryParams = this.$route.query;
      delete queryParams.mobile; // 删除 mobile，避免 URL 里重复
      delete queryParams.type; // 删除 type，避免 URL 里重复
      let queryString = Object.keys(queryParams).length
        ? '&' + Object.entries(queryParams)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&')
        : '';
      let url = '/api/user/sub?mobile='+mobile +'&type='+type+queryString
      that.$api.get(url, {},r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          if (r.code === 1){
            that.$parent.returnCode(r,function(){
              localStorage.setItem('token',r.data.userinfo.token)
              localStorage.setItem('mobile',r.data.userinfo.mobile)
              that.$router.push('/');
            });
          }else{
            that.$utils.alertText(r.msg,80, 3000);
          }
        });
      })
    },
    //测试阶段任意号码直接登录
    testLogin(){
      let that = this
      let mobile = '09'+this.mobile
      that.$parent.loadModal(true);
      let url = '/api/user/check_user'
      let data = {
        mobile:mobile
      }
      that.$api.post(url,data,r =>{
        that.$parent.loadModal(false);
        if(r.code === 1){
          localStorage.setItem('token',r.data.userinfo.token)
          localStorage.setItem('mobile',r.data.userinfo.mobile)
          this.$router.push({path:'/'})
          //window.location.href = r.data;
        }else{
          that.$utils.alertText(r.msg,80);
        }
      })
    }
	}
}
</script>
<style scoped>
.login-page {
  position: relative;
  width: 100%;
  min-height: 196vw;
  min-height: max(100svh, 196vw);
  overflow: hidden;
  color: #fff;
  background: #080036 url('../../static/images/land/main_bg.jpg') center top / 100% 100% no-repeat;
}

.login-logo,
.login-title-art,
.login-prize-art,
.login-form-heading img,
.login-phone-field-bg,
.login-phone-prefix,
.login-subscribe-button img {
  display: block;
  user-select: none;
  pointer-events: none;
}

.login-logo {
  position: absolute;
  z-index: 3;
  top: 4.8%;
  left: 50%;
  width: 17.5%;
  transform: translateX(-50%);
}

.login-title-art {
  position: absolute;
  z-index: 2;
  top: 14.1%;
  left: 50%;
  width: 94%;
  transform: translateX(-50%);
}

.login-prize-art {
  position: absolute;
  z-index: 1;
  top: 4.9%;
  left: 50%;
  width: 100%;
  transform: translateX(-50%);
}

.login-form-area {
  position: absolute;
  z-index: 4;
  top: 66.8%;
  right: 8%;
  left: 8%;
}

.login-form-heading {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  color: #fff;
  font-size: clamp(17px, 4.5vw, 34px);
  font-weight: 500;
  line-height: 1;
  text-align: center;
  text-shadow: 0 2px 4px rgba(72, 0, 72, .8);
}

.login-form-heading img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 88%;
  height: auto;
  transform: translate(-50%, -50%);
}

.login-form-heading span {
  position: relative;
  z-index: 1;
  padding: 0 5%;
}

.login-phone-field {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 6.2%;
  aspect-ratio: 956 / 171;
}

.login-phone-field-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.login-phone-prefix {
  position: relative;
  z-index: 2;
  flex: 0 0 auto;
  width: 23.33%;
  margin-left: -.15%;
}

.login-phone-input {
  position: relative;
  z-index: 2;
  width: calc(76.67% - 2.5%);
  height: 100%;
  padding: 0 4% 0 3%;
  border: 0;
  color: #fff;
  background: transparent;
  font-family: inherit;
  font-size: clamp(23px, 7.4vw, 56px);
  font-weight: 700;
  line-height: 1;
}

.login-subscribe-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 58%;
  margin: 9.4% auto 0;
  padding: 0;
  border: 0;
  color: #fff;
  background: transparent;
  font-family: inherit;
  font-size: clamp(20px, 6.1vw, 46px);
  font-weight: 900;
  line-height: 1;
  letter-spacing: .01em;
  text-align: center;
  text-transform: uppercase;
  text-shadow: 0 3px 0 rgba(115, 0, 55, .68), 0 5px 8px rgba(59, 0, 55, .42);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.login-subscribe-button img {
  width: 100%;
  height: auto;
}

.login-subscribe-button span {
  position: absolute;
  top: 50%;
  right: 7%;
  left: 7%;
  transform: translateY(-50%);
  white-space: nowrap;
}

.login-subscribe-button .login-subscribe-label-burmese {
  font-size: clamp(17px, 4.8vw, 37px);
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.login-subscribe-button:active { transform: translateY(1.5%); }

.login-footer {
  position: absolute;
  z-index: 4;
  right: 13%;
  bottom: 3.7%;
  left: 13%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.login-footer-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26%;
  padding: 0;
  border: 0;
  color: #fff;
  background: transparent;
  font-family: inherit;
  font-size: clamp(15px, 4.4vw, 34px);
  font-weight: 900;
  line-height: 1;
  letter-spacing: -.02em;
  text-shadow: 0 3px 5px rgba(27, 0, 63, .9);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.login-footer-link:active { transform: translateY(1px); }
</style>



// WEBPACK FOOTER //
// src/page/Login.vue